import React, { Component } from 'react'
import styles from './index.module.less'
import Title from './Title'
import { Layout, Button, Card } from 'antd';
import GFooter from '@/components/GlobalFooter'
import Content1 from './Content1'

export default class SolveLayout extends Component {
  state = {
    tabKey: 'funding_party'
  }
    /**
   * 暂时无HTTP请求
   */
  onTabChange = key => {
    // const { match } = this.props;
    // switch (key) {
    //   case 'articles':
    //     router.push(`${match.url}/articles`);
    //     break;
    //   case 'applications':
    //     router.push(`${match.url}/applications`);
    //     break;
    //   case 'projects':
    //     router.push(`${match.url}/projects`);
    //     break;
    //   default:
    //     break;
    // }
    switch (key) {
      case 'funding_party':
        this.setState({ 
          tabKey: 'funding_party'
        });
        break;
      case 'safety_identify':
        this.setState({ 
          tabKey: 'safety_identify'
        });
      default:
        break;
    }
  };

  render() {

    const operationTabList = [
      {
        key: 'funding_party',
        tab: (
          <span>
            资金方
          </span>
        ),
      },
      {
        key: 'safety_identify',
        tab: (
          <span>
            安全认证
          </span>
        ),
      }
    ];
    const tabKey = this.state.tabKey;
    let content;
    content = tabKey == 'funding_party' ? <Content1 /> : ''
    return (
      <Layout>
        {/* 搜索区 */}
        <Layout.Header className={styles.header}>
          <Title></Title>
        </Layout.Header>
        <Layout.Content className={styles.content}>
          {/* 内容区 Card内带tabs */}
          <Card
              className={styles.tabsCard}
              // style={{padding: '0'}}
              bordered={false}
              tabList={operationTabList}
              // activeTabKey={location.pathname.replace(`${match.path}/`, '')}
              activeTabKey={this.state.tabKey}
              onTabChange={this.onTabChange}
            >
              {content}
          </Card>
        </Layout.Content>
        <Layout.Footer className={styles.footer}>
            <GFooter></GFooter>
        </Layout.Footer >
      </Layout>
    )
  }
}